import { TilePuzzlePostInput } from '../../templates/inputs/TilePuzzlePostInput';
import { isTilePuzzlePost } from '../PostTypes';
import { TilePuzzlePostData } from '../types/TilePuzzlePostData';
import { defineTemplate } from './TemplateUtils';

export const TilePuzzleLarge = defineTemplate(
    'TilePuzzle',
    'Large',
    TilePuzzlePostInput,
    () =>
        ({
            $type: 'TilePuzzle',
            size: 'Large',
        }) satisfies TilePuzzlePostData,
    isTilePuzzlePost,
);
